import {getTrackingLink} from './getTrackingLink'

export const airbridge = {
  getTrackingLink,
}
